import { render, staticRenderFns } from "./AddEmployeeDialog.vue?vue&type=template&id=67645240"
import script from "./AddEmployeeDialog.vue?vue&type=script&lang=js"
export * from "./AddEmployeeDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports